import { FC, SVGProps } from 'react'

export const Eye: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.75 18C7.96627 18 4.71174 15.41 3.5349 11.75C4.71174 8.08998 7.96627 5.5 11.75 5.5C15.5346 5.5 18.7883 8.08993 19.9651 11.75C18.7883 15.4101 15.5346 18 11.75 18ZM11.75 4C7.16132 4 3.31689 7.19513 2.03088 11.537C1.98971 11.676 1.98971 11.824 2.03088 11.963C3.31689 16.3049 7.16132 19.5 11.75 19.5C16.3397 19.5 20.1831 16.3048 21.4691 11.963C21.5103 11.824 21.5103 11.676 21.4691 11.537C20.1831 7.19518 16.3397 4 11.75 4ZM10.2943 10.1433C10.6881 9.72573 11.2126 9.5 11.7495 9.5C12.2864 9.5 12.8109 9.72573 13.2047 10.1433C13.6 10.5623 13.8291 11.1396 13.8291 11.75C13.8291 12.3604 13.6 12.9377 13.2047 13.3567C12.8109 13.7743 12.2864 14 11.7495 14C11.2126 14 10.6881 13.7743 10.2943 13.3567C9.89905 12.9377 9.66992 12.3604 9.66992 11.75C9.66992 11.1396 9.89905 10.5623 10.2943 10.1433ZM11.7495 8C10.7855 8 9.87056 8.40641 9.20309 9.11407C8.53703 9.82025 8.16992 10.7691 8.16992 11.75C8.16992 12.7309 8.53703 13.6798 9.20309 14.3859C9.87056 15.0936 10.7855 15.5 11.7495 15.5C12.7135 15.5 13.6285 15.0936 14.2959 14.3859C14.962 13.6798 15.3291 12.7309 15.3291 11.75C15.3291 10.7691 14.962 9.82025 14.2959 9.11407C13.6285 8.40641 12.7135 8 11.7495 8Z"
			fill="currentColor"
		/>
	</svg>
)
